import { MonitorUp, Pause, PictureInPicture2, Play, Square } from 'lucide-react';
import { surfaceOf } from '../lib/media';
import { useStore } from '../lib/store';
import type { MeetingSession } from '../meeting/MeetingSession';
import { floatingSupported, openFloating, useFloatingOpen } from './floating';

/** Zoom-style bar shown while you share: status, pause, new share, floating window, stop. */
export function ShareBar({ session, onChange }: { session: MeetingSession; onChange(): void }) {
  const s = useStore(session.store);
  const floatingOpen = useFloatingOpen();
  if (!s.screenStream) return null;
  const surface = surfaceOf(s.screenStream);
  const what =
    s.shareKind === 'image' ? 'una imagen' : surface === 'window' ? 'una ventana' : surface === 'browser' ? 'una pestaña' : 'la pantalla';
  const hasAudio = s.screenStream.getAudioTracks().length > 0;

  return (
    <div className="share-bar" role="toolbar" aria-label="Controles de pantalla compartida">
      <span className={`share-status ${s.sharePaused ? 'paused' : ''}`} role="status">
        <span className="live-dot" aria-hidden />
        {s.sharePaused ? `Has pausado ${what}` : `Estás compartiendo ${what}`}
        {hasAudio && !s.sharePaused && <span className="share-tag">con sonido</span>}
      </span>
      <button type="button" className="share-bar-btn" onClick={() => session.setSharePaused(!s.sharePaused)}>
        {s.sharePaused ? <Play size={16} /> : <Pause size={16} />}
        {s.sharePaused ? 'Reanudar' : 'Pausar'}
      </button>
      <button type="button" className="share-bar-btn" onClick={onChange}>
        <MonitorUp size={16} /> Nueva fuente
      </button>
      {floatingSupported() && !floatingOpen && (
        <button type="button" className="share-bar-btn" onClick={() => void openFloating(session, { forShare: true })}>
          <PictureInPicture2 size={16} /> Barra flotante
        </button>
      )}
      <button type="button" className="share-bar-btn stop" onClick={() => session.stopShare()}>
        <Square size={14} fill="currentColor" /> Dejar de compartir
      </button>
    </div>
  );
}
